module.exports = __webpack_public_path__ + "img/icon_link_button.c88115b4.svg";